import { BaseElement } from 'base';
import { runAction } from 'run-action';

class DrawerHeader extends BaseElement {
  #action = null;

  onConnect() {
    const close = this.q('[data-drawer-close]');
    if (close) this.listen(close, 'click', this.onClose);
  }

  run(action) {
    this.#action = action;
    return this;
  }

  setCountHidden(isHidden) {
    const count = this.q('.drawer-header__count');
    if (count) count.hidden = Boolean(isHidden);
    return this;
  }

  onClose() {
    if (this.dataset.disabled === 'true') return;

    runAction(this, this.#action, undefined, 'drawer-header');
  }
}

if (!customElements.get('drawer-header'))
  customElements.define('drawer-header', DrawerHeader);
